import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const loanInstallmentsStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '2.5%',
    borderRadius: '10px',
    [theme.breakpoints.down('md')]: {
      padding: '1%',
    },

  },
  heading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    width: '100% !important',
    borderRadius: '10px 10px 0px 0px !important',
    cursor: 'default !important',
    display: 'flex !important',
    justifyContent: 'space-between !important',
    backgroundColor: `${theme.palette.background.darkSecondary} !important`,
    color: `${theme.palette.white.main} !important`,
  },
  AccordionDetails: {
    display: 'grid',
    padding: '2% auto',
    paddingLeft: '100px',
    paddingRight: '100px',
    border: `1px solid ${theme.palette.background.dark}`,
    borderRadius: '0px 0px 10px 10px',
  },
  TableContainer: {
    height: '390px',
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5,
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '8px',
      boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
      marginTop: '70px',
      transition: '2s',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      backgroundColor: '#000000',
      transition: '2s',
    },
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
    },

  },
  ReponsiveCell: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },

  },
  ResponsiveTitle: {
    alignSelf: 'center',
    textAlign: 'right',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  DialogTitle: {
    backgroundColor: theme.palette.primary.main,
  },

}));

export default loanInstallmentsStyles;
